import { render } from "./offer.vue?vue&type=template&id=4c5f8206"
import script from "./offer.vue?vue&type=script&lang=js"
export * from "./offer.vue?vue&type=script&lang=js"

import "./offer.vue?vue&type=style&index=0&id=4c5f8206&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__